import { Component, OnInit, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { MenuService } from '../shared/service/menu.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cabecalho',
  templateUrl: './cabecalho.component.html',
  styleUrls: ['./cabecalho.component.scss'],
})
export class CabecalhoComponent implements OnInit {

  constructor(
    private menuService: MenuService,
    private router: Router,
  ) {
  }

  formularioBarraPesquisa: FormGroup;
  stringBusca: string;

  @Output() altoContraste = new EventEmitter<any>();
  @Input() contraste: boolean;

  isDropdownAcessoRapido = false;
  isDropdownFuncionalidades = false;
  isSearch = false;

  ngOnInit(): void {
    this.formularioBarraPesquisa = new FormGroup({
      stringBusca: new FormControl(null),
    });
  }

  onAltoContraste() {
    this.contraste = !this.contraste;
    this.altoContraste.emit(this.contraste);
  }

  toggleMenu() {
    this.menuService.toggleMenu(); // Alterna a visibilidade do menu.
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;
  }

  toggleDropdown(menu: string, event: Event) {
    event.stopPropagation(); // Impede que o clique no botão feche o menu imediatamente

    if (menu === 'acessoRapido') {
      this.isDropdownAcessoRapido = !this.isDropdownAcessoRapido;
      this.isDropdownFuncionalidades = false;
    } else if (menu === 'funcionalidades') {
      this.isDropdownFuncionalidades = !this.isDropdownFuncionalidades;
      this.isDropdownAcessoRapido = false;
    }
  }

  /**
   * Detecta cliques fora dos menus e os fecha automaticamente.
   * @param event elemento alvo.
   */
  @HostListener('document:click', ['$event'])
  fecharDropdowns(event: Event) {
    const target = event.target as HTMLElement;
    // Se o clique for fora dos dropdowns, fecha tudo.
    if (!target.closest('.dropdown')) {
      this.isDropdownAcessoRapido = false;
      this.isDropdownFuncionalidades = false;
    }
  }

  /**
   * Pesquisa dados do catálogo.
   */
  onPesquisar() {
    this.stringBusca = this.formularioBarraPesquisa.get('stringBusca').value;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/pesquisa'], {
        queryParamsHandling: 'merge',
        queryParams: { query: this.stringBusca, pagina: 1 },
      });
      this.formularioBarraPesquisa.reset();
    });
  }

  reloadPage() {
    window.location.reload();
  }

}
